import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { List, ListItem, ListItemText, Collapse, Grid } from '@material-ui/core';
import '../style/nav.css';

export class Nav extends Component {
	render() {
		return (
			<div className="nav">
                <div style={{position: 'relative'}}>
                    <span className="title">
                        <Link to={{ pathname: '/', state: { test: 2 } }}>
                            <p style={{marginBottom: 0, display: 'inline', verticalAlign: 'top'}}>E. Cobb</p>
							<div style={{display: 'inline-block', paddingLeft: '.4em', opacity: .6, }}>
								<p style={{display: 'block', marginBottom: 0}}> Architects </p>
								<p style={{display: 'block', marginBottom: 0, fontSize: '.5em', textAlignLast: 'justify'}}> P a r t n e r s </p>
							</div>
                        </Link>
                    </span>
					<div style={{display: 'inline-block', marginTop:'0em', position: 'absolute', height: '100%'}}>
						<div className="dropdown">
							<Link to="/projects/residential"> residential </Link>
							<div className="dropdown-content">
								<Link style={{ padding: 0 }} to="/projects/residential/date">
									date
								</Link>
								<Link to="/projects/residential/alphabetical"> alphabetical </Link>
							</div>
						</div>
						<div className="dropdown">
							<Link to="/projects/commercial"> commercial </Link>
							<div className="dropdown-content">
								<Link style={{ padding: 0 }} to="/projects/commercial/date">
									date
								</Link>
								<Link to="/projects/commercial/alphabetical"> alphabetical </Link>
							</div>
						</div>
						<div className="dropdown">
							<Link to="/contact">
								<font>contact </font>
							</Link>
						</div>
						<div className="dropdown right" style={{paddingRight: 0}}>
							<Link to="/firm">
								<font>firm </font>
							</Link>
						</div>
						<Link className="dropdown" to="/search" style={{
								display:'block', 
								backgroundColor: 'rgba(0,0,0,.9)',
								position: 'absolute',
								bottom: '.6em',
								width: '100%'
							}}>
								<font color="orange">AI Gallery Search </font>
						</Link>
					</div>
                </div>
			</div>
		);
	}
}

export class MobileNav extends Component {
	componentWillMount() {
		this.setState({ open: false });
	}

	close() {
		this.setState({ open: false });
	}
	render() {
		return (
			<div className="mobileNav">
				<List disablePadding style={{ color: '#DCDCDC !important' }}>
					<ListItem button onClick={() => this.setState({ open: !this.state.open })}>
						<ListItemText
							primary="E. Cobb Architects"
							primaryTypographyProps={{
								style: {
									paddingLeft: '0 !important',
									fontFamily: 'Futura-Std-Light',
									fontSize: '25px',
									color: '#DCDCDC'
								}
							}}
						/>
					</ListItem>
					<Collapse in={this.state.open} timeout="auto" unmountOnExit style={{ fontSize: '.8em' }}>
						<Grid container spacing={0}>
							<Grid item xs={6}>
								<List component="div" disablePadding>
									<Link to="/">
										<ListItem button dense onClick={() => this.close()}>
											home
										</ListItem>
									</Link>
									<Link to="/projects/residential">
										<ListItem button dense onClick={() => this.close()}>
											residential
										</ListItem>
									</Link>
									<Link to="/projects/commercial">
										<ListItem button dense onClick={() => this.close()}>
											commercial
										</ListItem>
									</Link>
								</List>
							</Grid>
							<Grid item xs={6}>
								<List component="div" disablePadding>
									<Link to="/search">
										<ListItem button dense onClick={() => this.close()}>
											search
										</ListItem>
									</Link>
									<Link to="/contact">
										<ListItem button dense onClick={() => this.close()}>
											contact
										</ListItem>
									</Link>
									<Link to="/firm">
										<ListItem button dense onClick={() => this.close()}>
											firm
										</ListItem>
									</Link>
								</List>
							</Grid>
						</Grid>
					</Collapse>
				</List>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/nav.js